import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Components
import { MainButton } from '../../inputs/buttons/MainButton';
import { Text } from '../../inputs/buttons/MainButton/styles';
import { Typography } from '../Typography';
import { Container as ContainerButton } from '../../inputs/buttons/MainButton/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  max-width: 23.6rem;
  box-shadow: ${({ theme }) => theme.shadows.dropdown};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.m} 3rem
    ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  align-self: flex-end;
  position: absolute;
  z-index: 999999;
  margin-top: 5.8rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    max-width: 24.9rem;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
`;

export const HorizontalLine = styled.div`
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greySoftLight};
  max-width: 18.1rem;
`;

export const ContainerUser = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    gap: 0.4rem;
  }
`;

export const ContainerUserNameRole = styled.div``;

export const ButtonSession = styled(MainButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: 14.9rem;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    &${ContainerButton} {
      height: 4rem;
    }
  }

  ${Text} {
    @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
      theme.percentBaseResponsive}rem) {
      font-size: ${({ theme }) => theme.fontSize.S};
    }
  }
`;

export const ContainerButtonPolicy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const LinkPolicy = styled(Link)`
  text-decoration: none;
`;

export const TextSection = styled(Typography)`
  font-size: 1.2rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XXXS};
  }
`;

export const PolicyVersionContainer = styled.div``;

export const EmailText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClearCacheButton = styled(MainButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: 14.9rem;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    &${ContainerButton} {
      height: 4rem;
    }
  }

  ${Text} {
    @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
      theme.percentBaseResponsive}rem) {
      font-size: ${({ theme }) => theme.fontSize.S};
    }
  }
`;

export const ChangePasswordButton = styled(MainButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: 18rem; /* Más ancho que ClearCacheButton para acomodar "Canviar contrasenya" */
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    &${ContainerButton} {
      height: 4rem;
    }
  }

  ${Text} {
    @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
      theme.percentBaseResponsive}rem) {
      font-size: ${({ theme }) => theme.fontSize.S};
    }
  }
`;
